import { cn } from "./cn";

/**
 * The Empite mark from /logo.svg.
 *
 * Drawn as a background image rather than inline SVG: the file carries its own
 * gradients and filter ids, and the mark renders several times per page (the
 * sidebar rail and its mobile drawer, for one), so inlining would duplicate
 * those ids into the document. Size it with a `size-*` class.
 */
export function Logo({
  className,
  label = "Empite",
}: {
  className?: string;
  label?: string;
}) {
  return (
    <span
      role="img"
      aria-label={label}
      className={cn(
        "block shrink-0 bg-[url(/logo.svg)] bg-contain bg-center bg-no-repeat",
        className,
      )}
    />
  );
}
